export const ICON_MAP = {
  'tachometer-alt': 'gaikuang',
  'shopping-bag': 'shangpin',
  'clipboard-list': 'jiaoyi',
  'store-alt': 'jingxiaoshang',
  'gem1': 'huiyuan',
  'brush': 'moban',
  'gift': 'yingxiao',
  'file-invoice-dollar': 'caiwu',
  'chart-bar': 'tongji',
  'sitemap': 'zhandian',
  'yingyong-01': 'yingyong',
  'cog': 'shezhi'
}

export const SALES_STATUS = [
  { title: '前臺可銷售', value: 'onsale' },
  { title: '前臺不展示', value: 'offline_sale' },
  { title: '前臺僅展示', value: 'only_show' },
  { title: '不可銷售', value: 'instock' }
]

export const DISTRIBUTION_TYPE = [
  { title: '全部', value: '' },
  { title: '普通快遞', value: 'logistics' },
  { title: '同城配', value: 'dada' },
  { title: '客戶自取', value: 'ziti' },
  { title: 'Panda', value: 'pandago' },
  { title: 'Uber', value: 'uber' }
]

export const DISTRIBUTION_TYPE_DISTRIBUTOR = [
  { title: '全部', value: '' },
  { title: '到店取貨', value: 'ziti' },
  { title: 'Panda', value: 'pandago' },
  { title: 'Uber', value: 'uber' }
]

export const ORDER_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '已出貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  // { title: '待自取', value: 'ziti' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' },
  // { title: '待接單', value: 'hourlyDelivery_0' },
  // { title: '待騎士接單', value: 'hourlyDelivery_10' },
  // { title: '待取貨', value: 'hourlyDelivery_30' },
  // { title: '配送中', value: 'hourlyDelivery_40' },
  // { title: '配送失敗 / 反送', value: 'hourlyDelivery_120' }
  // { title: '待接單', value: 'dada_0' },
  // { title: '待騎士接單', value: 'dada_1' },
  // { title: '待取貨', value: 'dada_2' },
  // { title: '騎士到店', value: 'dada_100' },
  // { title: '配送中', value: 'dada_3' },
  // { title: '未妥投', value: 'dada_9' }
]

export const ORDER_DISTRIBUTOR_STATUS = [
  { title: '全部', value: '' },
  { title: '已完成', value: 'finish' },
  { title: '待付款', value: 'notpay' },
  { title: '待接單', value: 'hourlyDelivery_0' },
  { title: '待騎士接單', value: 'hourlyDelivery_10' },
  { title: '待取貨', value: 'hourlyDelivery_30' },
  { title: '配送中', value: 'hourlyDelivery_40' },
  { title: '配送失敗 / 反送', value: 'hourlyDelivery_120' }
]

export const ORDER_B2C_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '已出貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  { title: '待自取', value: 'ziti' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' }
]

export const IN_PURCHASE_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '已出貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' }
  // { title: '配送中', value: 'dada_3' }
]

export const ORDER_TYPE = [
  { title: '全部', value: '' },
  { title: '團購訂單', value: 'groups' },
  { title: '秒殺訂單', value: 'seckill' },
  { title: '普通訂單', value: 'normal' },
  { title: '社群團購訂單', value: 'community' }
  // { title: "導購訂單", value: "shopguide" },
  // { title: "跨境訂單", value: "crossborder" },
  // { title: "助力訂單", value: "bargain" },
  // { title: "服務類訂單", value: "services" },
  // { title: "兌換訂單", value: "excard"}
]

export const ORDER_TYPE_STANDARD = [
  { title: '全部', value: '' },
  { title: '團購訂單', value: 'groups' },
  { title: '秒殺訂單', value: 'seckill' },
  { title: '普通訂單', value: 'normal' },
  { title: '社群團購訂單', value: 'community' },
  { title: '兌換訂單', value: 'excard' },
  { title: '門市訂單', value: 'shopadmin' },
  { title: '立即配訂單', value: 'expresshour' }
]

export const ORDER_TYPE_STANDARD_DISTRIBUTOR = [
  { title: '全部', value: '' },
  { title: '門市訂單', value: 'shopadmin' },
  { title: '立即配訂單', value: 'expresshour' }
]

export const INVOICE_STATUS = [
  { title: '全部', value: '' },
  { title: '未開票', value: 0 },
  { title: '已開立發票', value: 1 }
]

export const INVOICE_STATUS_DISTRIBUTOR = [
  { title: '全部', value: '' },
  { title: '未開立發票', value: 0 },
  { title: '已開立發票', value: 1 }
]

export const ORDER_CATEGORY = [
  { title: '全部', value: '' },
  { title: '自營訂單', value: 'self' },
  { title: '商家訂單', value: 'shop' }
]

export const REFUND_STATUS = {
  READY: '待稽核',
  AUDIT_SUCCESS: '稽核成功待退款',
  SUCCESS: '退款成功',
  SHOP_CHECK_FAILS: '商家稽核不透過',
  CANCEL: '撤銷退款',
  PROCESSING: '已發起退款等待到賬',
  FAILS: '退款失敗',
  WAIT_CHECK: '待稽核',
  WAIT_REFUND: '等待退款'
}

export const REFUND_PROCESS = {
  0: '待處理',
  1: '已取消',
  2: '退款中',
  3: '已完成',
  4: '已駁回'
}

export const PROFIT_TYPE = {
  1: '總部分潤',
  2: '自營門市分潤',
  3: '加盟門市分潤'
}

export const PAY_TYPE = {
  wxpay: '微信支付',
  amorepay: '微信支付',
  wechat: '微信支付',
  wepayjs: '微信支付',
  wxpaypc: '微信PC支付',
  wxpayh5: '微信H5支付',
  alipay: '支付寶支付',
  alipayh5: '支付寶H5支付',
  deposit: '餘額支付',
  point: '紅利積點支付',
  // pos: 'POS提款卡支付',
  pos: '現金支付',
  wxpaypos: '微信掃碼支付',
  alipaypos: '支付寶掃碼支付',
  chinaums: '微信支付-銀聯',
  // pay_channel
  wx_lite: '微信支付',
  wx_pub: '微信H5支付',
  wx_qr: '微信PC支付',
  alipay_wap: '支付寶H5支付',
  alipay_qr: '支付寶PC支付',
  alipaymini: '支付寶小程式',
  ecpay_h5: '綠界支付'
}

export const PAY_STATUS = {
  SUCCESS: '支付成功',
  REFUND: '轉入退款',
  CANCEL_CLOSED: '已取消',
  REFUND_SUCCESS: '退款成功',
  NOTPAY: '未支付',
  CLOSED: '已關閉',
  REVOKED: '已撤銷',
  PAYERROR: '支付失敗(其他原因，如銀行返回失敗)'
}

export const PICKER_DATE_OPTIONS = {
  shortcuts: [
    {
      text: '最近一週',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近一個月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近三個月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

export const FORM_COMP = {
  INPUT: 1,
  NUMBER: 2,
  DATE: 3,
  RADIO: 4,
  CHECKBOX: 5,
  MOBILE: 6,
  IMAGE: 7
}

export const SYSTEM_CONFIG = {
  platform: { name: 'Powered By ShopeX', theme: '#CB060F' },
  standard: { name: '商派Onex雲店', theme: '#FF9D00' },
  b2c: { name: '商派官方商城', theme: '#157FE3' },
  in_purchase: { name: '商派Onex內購', theme: '#EC442E' }
}

export const LINK_PATH = {
  'goods': '商品',
  'store': '店鋪',
  'sale_category': '銷售分類',
  'category': '管理分類',
  'tag': '商品標籤',
  'article': '文章',
  'planting': '業配文',
  'link': '頁面',
  'marketing': '營銷',
  'regactivity': '活動報名',
  'seckill': '秒殺',
  'custom_page': '自定義頁面',
  'liverooms': '直播',
  'other_wxapp': '外部小程式',
  'hourly_delivery': '小時達入口'
}

export const CARD_TYPE = {
  'discount': '折扣券',
  'cash': '滿減券',
  'new_gift': '兌換券'
}

export const SECKILL_ACTIVITY_STATUS = {
  'waiting': '待開始',
  'in_the_notice': '預熱中',
  'in_sale': '進行中',
  'it_has_ended': '已結束'
}
